/**
 * Ajuda dos campos da tela de logs (P-LOG): os filtros das abas Auditoria, Acessos e
 * Tarefas.
 *
 * Juntada em `../ajudaDosCampos.ts`, que explica a chave e o texto. Ver
 * docs/FRONTEND.md, secao 6.
 */
export const ajuda: Record<string, Record<string, string>> = {
  '/logs': {
    'Data inicial': 'Primeiro dia do periodo, no horario de Brasilia.',
    'Data final': 'Ultimo dia do periodo, incluido inteiro.',
    Quem: 'Nome ou e-mail de quem fez a acao, ou parte dele, sem diferenca de maiusculas.',
    Modulo:
      'Primeiro trecho da acao, como operacoes, tomadores ou configuracoes. Traz todas as acoes daquele modulo.',
    'Tipo de entidade':
      'O cadastro que a acao alterou, como tomador, corretor ou operacao. Use com o identificador para ver a historia de um registro so.',
    'Identificador da entidade':
      'O identificador do registro, como aparece no endereco da tela de detalhe. Traz so as acoes sobre ele.',
    Evento:
      'O tipo de acesso: entrada, saida, renovacao da sessao, troca de senha ou de empresa. A falha de entrada nao tem empresa e nao aparece aqui.',
    'E-mail de quem entrou':
      'E-mail da pessoa, ou parte dele. So vale para quem le os usuarios da empresa; para os demais o e-mail aparece mascarado.',
    Rotina: 'Comeco do nome da rotina automatica, como operacoes.',
    'Situacao da rotina':
      'Em andamento, concluida, com falha ou ignorada. Ignorada quer dizer que a rotina correu e nao tinha o que fazer.',
  },
};
